import React, { useEffect } from 'react';
import Footer from '../components/Footer'
import { motion } from 'framer-motion';
import aboutImage from '../images/about.jpg';

const About = () => {


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fadeInUp = {
        hidden: { opacity: 0, y: -40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
    };

    const slideInLeft = {
        hidden: { opacity: 0, x: -50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
    };

    const slideInRight = {
        hidden: { opacity: 0, x: 50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
    };
    return (
        <div>

            <div className="container my-4">
                <div className="d-flex justify-content-center">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb bg-light p-2 rounded">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">About Us</li>
                        </ol>
                    </nav>
                </div>
            </div>



            <section className="py-5" id="about" aria-labelledby="about-heading">
                <div className="container">
                    {/* Section Header */}
                    <motion.div
                        className="text-center mb-5"
                        initial="hidden"
                        whileInView="visible"
                        variants={fadeInUp}
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <h2 id="about-heading" className="display-4 fw-bold  mb-3" style={{ color: '#b6291e' }} >
                            AROGYA KUNJ HOMOEOPATHIC CLINIC
                        </h2>
                        <p className="lead text-muted">
                            Healing With Classical Homoeopathy - Gentle, Permanent, & Holistic
                        </p>
                        <p style={{ color: '#b6291e' }}>"होम्योपैथीः-जहाँ इलाज सिर्फ लक्षणों का नहीं, बल्कि पूरी सेहत का होता है!" </p>
                    </motion.div>

                    {/* Content Row */}
                    <div className="row g-4 align-items-center">
                        {/* Image */}
                        <motion.div
                            className="col-md-6"
                            initial="hidden"
                            whileInView="visible"
                            variants={slideInLeft}
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            <img
                                src={aboutImage}
                                alt="Healthcare professionals"
                                className="img-fluid rounded shadow"
                            />
                        </motion.div>

                        {/* Text Content */}
                        <motion.div
                            className="col-md-6"
                            initial="hidden"
                            whileInView="visible"
                            variants={slideInRight}
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            <h3 className="h4 fw-semibold  mb-3">DR. SHUBHAM KUMAR B.H.M.S, MD (HOMOEOPATHY)  </h3>
                            <p className=" mb-4" style={{ color: '#02532b', textAlign: 'justify' }}>
                                At AROGYAKUNJ HOMOEOPATHIC CLINIC, we follow a holistic and classical homeopathic approach to restore health naturally. Homeopathy works by stimulating the body’s innate healing power, addressing the root cause rather than just symptoms.
                            </p>

                            <p style={{ color: '#02532b', textAlign: 'justify' }}>We specialize in treating acute and chronic diseases, including allergic rhinitis, asthma, sinusitis, eczema, psoriasis, acidity, IBS, arthritis, migraine, insomnia, hormonal imbalances, male health issues, childhood disorders, and mental stress. With individualized remedies, we ensure gentle, deep, and lasting healing. Experience true holistic wellness with Dr. Shubham."</p>



                            <p>Dr. Shubham is a dedicated and passionate homeopathic physician who completed his graduation from the prestigious Calcutta Homeopathic Medical College & Hospital, Kolkata — Asia’s first homeopathic medical institution. After successfully completing his undergraduate studies, internship, and serving as a House Physician at the same institution, he pursued his postgraduation (M.D.) from National Homeopathic Medical College & Hospital, Lucknow.</p>

                            <p>With a strong academic background and clinical expertise, Dr. Shubham has focused his postgraduate research on male infertility, reflecting his commitment to addressing complex and sensitive health issues through homeopathy. He has also contributed to the field by publishing six insightful articles on a range of homeopathic topics, further underlining his dedication to advancing the science and awareness of homeopathic medicine</p>
                        </motion.div>
                    </div>
                </div>
            </section>





            <Footer />
        </div>
    )
}

export default About